module.exports = __webpack_public_path__ + "5d7c5b.png";